<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Assign Video Board' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="modalDissmissed()" fill="clear" color="dark">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <form [formGroup]="assignVideoBoardForm">
  
      <ion-item>
        <ion-select [label]="'Venue' | translate" interface="popover" [placeholder]="'Select venue' | translate" formControlName="venue">
          @for (venue of venues$ | async; track $index) {
            <ion-select-option [value]="venue">{{ venue.venueAbbreviation }}</ion-select-option>
          }
        </ion-select>
      </ion-item>
  
      <ion-item>
        <ion-select [label]="'Court' | translate" interface="popover" [placeholder]="'Select venue' | translate" formControlName="court">
          @for (court of courts$ | async; track $index) {
            <ion-select-option [value]="court">{{ court.courtName }}</ion-select-option>
          }
        </ion-select>
      </ion-item>

      @if (assignVideoBoardForm.controls.court.value?.videoBoards.length) {
        <ion-item-divider color="light">
          <ion-label>{{ 'Video Boards' | translate }}</ion-label>
        </ion-item-divider>

        @for (videoBoard of assignVideoBoardForm.controls.court.value?.videoBoards; track $index) {
          <ion-item>
            <ion-toggle label-placement="start" (ionChange)="selectVideoBoards($event, videoBoard._id)">{{ videoBoard.name }}</ion-toggle>
          </ion-item>
        }
      }

      <ion-button class="ion-margin" (click)="assignSmartCourt()" expand="block">
        {{ 'Assign' | translate }}
      </ion-button>
    </form>
  </ion-list>

  @if (attachedVideoBoards.length) {
    <ion-item-divider color="medium" class="custom-divider">
      <ion-label>{{ 'Attached Video Boards to Match' | translate }}</ion-label>
    </ion-item-divider>

    <ion-list>
      @for (videoBoard of attachedVideoBoards; track $index) {
        <ion-item>
          <ion-label>{{ videoBoard.name }}</ion-label>
          <ion-button
            size="default"
            slot="end"
            color="danger"
            (click)="removeVideoBoard(videoBoard._id)"
            fill="clear"
          >
             {{ 'Remove Match' | translate }}
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          </ion-button>
        </ion-item>
      }
    </ion-list>
  }
</ion-content>